import * as React from 'react';
import { ComboBox, ListItemProps, ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import { fetchApi } from '../services/api';

type Props = {
    callbackFromParent: (data: ClassroomSearchResult) => void;
    childId?: number;
    className?: string;
    style?: {};
};

type State = {
    loading: boolean;
    opened: boolean;
    classroomResults: ClassroomSearchResult[];
}

export interface ClassroomSearchResult {
    ClassroomId: number;
    RoomName: string;
    RoomId: string;
    FacilityName: string;
    FacilityId: number;
}

export default class ClassroomComboBox extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            loading: false,
            opened: false,
            classroomResults: []
        };

        this.getClassrooms();
    };

    itemRender = (li: any, itemProps: ListItemProps) => {
        const itemChildren = <span style={{ fontSize: "14px", fontFamily: "Arial, Helvetica, sans-serif", whiteSpace: "nowrap", overflow: "hidden" }}>{itemProps.dataItem.RoomName}</span>;
        return React.cloneElement(li, li.props, itemChildren);
    }

    onChange = (event: ComboBoxChangeEvent) => {
        this.props.callbackFromParent(event.target.value);
    }

    private getClassrooms() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            ChildID: this.props.childId,
        }
        fetchApi('api/ChildClassrooms/List', data, 'POST')
            .then((data: ClassroomSearchResult[]) => {
                this.setState({ classroomResults: data, loading: false });
            });
    }

    public render() {
        return (
            <ComboBox
                data={this.state.classroomResults}
                //value={this.state.value}
                onChange={this.onChange}
                loading={this.state.loading}
                style={this.props.style}
                itemRender={this.itemRender}
                className={this.props.className}
                allowCustom={true}
                placeholder="Classroom"
                suggest={true}
                textField="RoomName"
            />
        );
    }
}
